import { ObjectDirective, DirectiveBinding } from 'vue';
import router from '@/router';
import { useSessionStore } from '@/stores/session.store';

const directive: ObjectDirective<HTMLElement> = {
  mounted: (el, binding: DirectiveBinding) => {
    if (!binding.value) {
      return;
    }
    const removeChild = document.createComment(' ');
    const sessionStore = useSessionStore();

    const evaluatePermission = () => {
      // On admin/lens-support routes all permissions are implicitly granted.
      // Use sessionStore.currentUser directly (not a destructured snapshot) so
      // the evaluation always reflects the latest store state.
      const routeMeta = router.currentRoute.value.meta;
      const isPrivilegedRoute = (routeMeta?.isAdmin || routeMeta?.isLensSupport) &&
        (sessionStore.currentUser?.is_admin || sessionStore.currentUser?.is_lens_support);

      if (isPrivilegedRoute) {
        if (removeChild.parentNode) {
          removeChild.parentNode.replaceChild(el, removeChild);
        }

        return;
      }

      if (binding.value?.length && !sessionStore.permissions.includes(binding.value)) {
        el.parentNode?.replaceChild(removeChild, el);
      } else if (removeChild.parentNode) {
        removeChild.parentNode.replaceChild(el, removeChild);
      }
    };

    evaluatePermission();
    (el as any).unwatch = sessionStore.$subscribe(evaluatePermission);
  },
  unmounted: (el) => {
    if ((el as any).unwatch) {
      (el as any).unwatch();
    }
  }
};

export default directive;
